export default {
    nav: '导航',
    phone: '手机号',
    email: '邮箱',
    transPwd: '交易密码',
    logout: '退出登录',
    confirmLogout: '确定退出登录？',
    logoutTips: '退出后，下次打开需重新登录账号',
    noSaveRecord: '此操作将不会保存您当前记录',
    confirm: '确定',

    phoneConsult: '电话咨询',
    onlineService: '联系客服',
    WeChatService: '企微客服',

    assets: '资产',
    assetsHome: '资产首页',
    deposit: '存入资金',
    withdraw: '提取资金',
    currencyExchange: '货币兑换',
    orderRecords: '订单记录',
    finance: '理财',
    financeHome: '理财首页',
    cashbox: '星财宝',
    publicFund: '公募基金',
    bill: '票据',
    bond: '债券',

    // contact组件
    contact: '联系我们',
    understood: '已了解',
    mainlandService: '内地客服',
    hongKongService: '香港客服',
    welcomeService: 'Hi～很高兴为您服务',

}
